export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10533.5427440c.jpg";